import React from 'react'
import Image from 'next/future/image'
import F1Heading from '@shared/components/F1Components/F1Heading'
import PropTypes from 'prop-types'
import styles from './style.module.scss'
import BreadcrumbNav from '@shared/components/breadcrumbNav'
import Formula1Layout from '../layout'
import { handleApiError } from '@shared-submodule/utils'
import CustomLink from '@shared/components/customLink'
import Layout from '@shared/components/layout'
import queryGraphql from '@shared/components/queryGraphql'
import { GRAPHQL_URL } from '@shared-submodule/sm-constants'

const PlayerCard = ({ name }) => (
  <div className={styles.playerData}>
    <span className={styles.playerNames}>{`${name?.sName} ${name?.sFamilyName}`}</span>
    <Image src={name?.sImgUrl} alt={name} width={65} height={65} className={styles.img} />
  </div>
)

PlayerCard.propTypes = {
  name: PropTypes.string
}

const Teams = ({ teamData, seoData }) => {
  return (
    <Layout data={{ oSeo: seoData }}>
      <Formula1Layout>
        <div className={styles.teamsLayout}>
          <div className="flex flex-column">
            <BreadcrumbNav />
            <F1Heading title="F1 Teams 2025" />
            <p className={styles.about}>
              Check out this season’s official F1 line-up, full breakdown of drivers, points and current positions.
            </p>
          </div>

          <div className={styles.teamList}>
            {(teamData?.data ?? []).map(data => (
              <div className={styles.team} key={data?.nPosition}>
                <CustomLink href={`/${data?.oSeo?.sSlug}`}>
                  <a className="position-absolute top-0 left-0 w-100 h-100"></a>
                </CustomLink>
                <div className={styles.data}>
                  <div className="d-flex flex-row gap-1 gap-md-3">
                    <span className={styles.rank}>#{data?.nPosition}</span>
                    <span className={styles.line}></span>
                    <span className={styles.rank}>{data?.oTeam?.sName}</span>
                  </div>
                  <div className={styles.points}>{data?.nPoints} Pts</div>
                </div>

                <div className={styles.playersList}>
                  {(data?.aDrivers ?? []).slice(0, 2).map((playerName, idx) => (
                    <PlayerCard key={playerName + idx} name={playerName} />
                  ))}
                </div>

                <div className={styles.car}>
                  <Image src={data?.sCarImgUrl} alt={`${data?.oTeam?.sName} car`} width={530} height={112} className={styles.carImg} />
                </div>
              </div>
            ))}
          </div>
        </div>
      </Formula1Layout>
    </Layout>
  )
}

Teams.propTypes = {
  seoData: PropTypes.object,
  teamData: PropTypes.array
}

export default Teams

export async function getServerSideProps({ res, resolvedUrl }) {
  try {
    res.setHeader('Cache-Control', 'public, max-age=600')

    const GET_SEO_DATA = (await import('@graphql/article/article.query')).GET_SEO_DATA
    const { data: seo } = await queryGraphql(GET_SEO_DATA, { input: { sSlug: 'formula1-racing/teams' } })

    const BASE_URL = GRAPHQL_URL.replace(/\/graphql$/, '')

    const urlTeams = new URL(`${BASE_URL}/api/global-widget/f1/teams`)
    urlTeams.searchParams.append('nYear', '2025')
    urlTeams.searchParams.append('nLimit', '10')

    const teamResponse = await fetch(urlTeams, {
      method: 'GET',
      headers: {
        'x-api-key': process.env.REACT_APP_API_KEY,
        'Content-Type': 'application/json'
      }
    })
    const teamData = await teamResponse.json()
    return {
      props: {
        seoData: seo?.getSeoData || {},
        teamData: teamData || {}
      }
    }
  } catch (e) {
    console.error('Error fetching data:', e)
    res.setHeader('Cache-Control', 'no-cache')
    const status = handleApiError(e, resolvedUrl)
    return status
  }
}
